module.exports = __webpack_public_path__ + "static/MobX-5f9bd24081ed1b8cd177527b84d96831.png";